import Pure from './pure';
export default Pure;
